import { render, staticRenderFns } from "./TabCustomerList.vue?vue&type=template&id=90963e76&scoped=true&"
import script from "./TabCustomerList.vue?vue&type=script&lang=js&"
export * from "./TabCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90963e76",
  null
  
)

export default component.exports